import {Box, Flex, Heading, HStack,Text
  } from "@chakra-ui/react";
import React,{ useState } from "react";
import {useLocation , useParams} from "react-router-dom";

import AutomatedTestCard from "../shared/components/AutomatedTestCard";
import TermsAndConditionsModal from "../shared/components/TermsAndConditionsModal";
import TestCard from "../shared/components/TestCard";
import {useAuthentication} from "../shared/hooks/AuthenticationProvider";
import {disableBlurProtection} from "../shared/hooks/BlurProtection";
import {useFont} from "../shared/hooks/FontProvider";
import {useTheme} from "../shared/hooks/ThemeProvider";
import {SkillType} from "../shared/model/Constants";
import {disableKeyCommands, isDemo} from "../shared/Utils";

const HomePelex = () => {
  const authentication = useAuthentication();
  const theme = useTheme().theme;
  const font = useFont().font;

  const [acceptsTC, setAcceptsTC] = useState<boolean>(authentication.currentUserQuery?.data?.data?.acceptTerms !== undefined ?
                                                          authentication.currentUserQuery?.data?.data?.acceptTerms : false);

  disableKeyCommands();
  disableBlurProtection();

  const html = document.getElementsByTagName("html").item(0);
  if (html !== null) html.style.height="auto";

  const params = useParams<{ test: string }>();
  const test = params.test || "";

  const demoMode = isDemo();

  const institution = authentication.currentUserQuery?.data?.data?.institution !== null ?
    authentication.currentUserQuery?.data?.data.institution : "";
  const region = authentication.currentUserQuery?.data?.data?.region !== null ?
    authentication.currentUserQuery?.data?.data.region : "";
  const institutionDisplay = institution && region ? institution+", "+region : ""+institution+region;
  // Bienvenido a las Pruebas de Dominio Lingüístico de la Universidad de Costa Rica Tweetalig, Colombia - 02/05/2023

  return (
    <Box maxW="container.xl" marginX="auto">
      <Box position="absolute" zIndex={-1}
           left={0} right={0} top="-4"
           width="100%" minH="90%"
           bgImage="/images/hero-bg.jpg" bgPosition="center top"
           bgRepeat="no-repeat" bgSize="cover"
      >
        <Box
          _before={{ content: '""', bgSize:"100%", background:theme.BG_HOME,position: "absolute",
            bottom: 0, top: 0, left: 0, right: 0, }} />
      </Box>
      <Flex justify="center" flexDirection="column" alignItems="center">
        <Heading maxW="xl" textAlign="center" color={theme.TEXT_SECONDARY}>
          Bienvenido a las Pruebas {demoMode?"de Práctica":""} de Dominio Lingüístico UCR {(new Date()).getFullYear()}
        </Heading>
        <Heading paddingTop="10" size="2xl" textAlign="center" color={theme.TEXT_SECONDARY} inlineSize="90vw">
          {authentication.currentUserQuery?.data?.data?.name}
          <br/>
          {authentication.currentUserQuery?.data?.data?.username}
          <br/>
          {institutionDisplay}
        </Heading>
        <Text paddingTop={10}
                  fontWeight={font.weight}
                  fontSize={font.h6}
         color={theme.TEXT_SECONDARY}>Seleccione la prueba que desee realizar</Text>

        <TermsAndConditionsModal acceptsTC={acceptsTC} setAcceptsTC={setAcceptsTC} readonly={true}/>

        <HStack alignSelf="start" spacing={10} paddingTop={30} alignItems="baseline">
          <TestCard name={'Lectura'+(demoMode?' Demo':'')}
                    description="Examen de Lectura"
                    skillType={SkillType.READING}
                    isDemo={demoMode}
                    autoStart={test !== undefined && test === SkillType.READING.toString()}
                    disabled={!acceptsTC}
          />
          <TestCard name={'Escucha'+(demoMode?' Demo':'')}
                    description="Examen de Escucha"
                    skillType={SkillType.LISTENING}
                    isDemo={demoMode}
                    autoStart={test !== undefined && test === SkillType.LISTENING.toString()}
                    disabled={!acceptsTC}
          />
          <TestCard name={'Certificación Oral'+(demoMode?' Demo':'')}
                    description="Examen Oral"
                    skillType={SkillType.SPEAKING}
                    isDemo={demoMode}
                    autoStart={test !== undefined && test === SkillType.SPEAKING.toString()}
                    disabled={!acceptsTC}
          />
          <AutomatedTestCard name={'Oral'+(demoMode?' Demo':'')}
                          description="Examen Oral"
                          isDemo={demoMode}
                          skillType={SkillType.SPEAKING}
                          autoStart={test !== undefined && test === SkillType.SPEAKING.toString()}
                          disabled={!acceptsTC}
          />
          <AutomatedTestCard name={'Escritura'+(demoMode?' Demo':'')}
                          description="Examen Escrito"
                          isDemo={demoMode}
                          skillType={SkillType.WRITING}
                          autoStart={test !== undefined && test === SkillType.WRITING.toString()}
                          disabled={!acceptsTC}
          />
        </HStack >
      </Flex>
    </Box>
  );
};

export default HomePelex;